/**
 * Displaying search bar
 */
$makeAppointmentBar = $('.js-make-appointment-bar');

$desktopAddressInput = $('.js-desktop-address-input');

$searchBarIconMobile = $('.js-search-icon-mobile');
$searchBarIconDesktop = $('.js-search-icon-desktop');

$searchBarInputDesktop = $('.js-search-bar-desktop');
$searchBarInputMobile = $('.js-search-bar-mobile');

$bookOnlineButton = $('.js-book-online');
$mobileAddressInput = $('.js-address-input');

$easilyBookOnline = $('.js-easily-book-online');

$searchBarIconMobile.on('click', function() {
    $mobileAddressInput.toggleClass('hidden');
    $desktopAddressInput.toggleClass('hidden');
    $searchBarInputMobile.toggleClass('hidden');

    if ($('body').hasClass('single-location') === false && $($makeAppointmentBar).hasClass('subpage') === false) {
        $makeAppointmentBar.toggle();
    }
});

$searchBarIconDesktop.on('click', function() {
    $bookOnlineButton.toggle();
    $searchBarIconDesktop.toggleClass('dim');
    $searchBarInputDesktop.toggleClass('hidden');
    $easilyBookOnline.toggleClass('hidden');

    if ($searchBarInputDesktop.is(':visible')) {
        $searchBarInputDesktop.find('input').focus();
    }
});

$bookOnlineButtonLink = $('.js-book-online-link');
$bookOnlineButtonLink.on('click', function(event) {
    if ($('.js-hubspot-form').length > 0) {
        event.preventDefault();

        window.scrollToObject($('.js-hubspot-form'));
    }
});

var mobile = ($(window).width() < 768 ? true : false);

$(window).resize(function() {

    if ($(window).width() < 768 && !mobile) {
        mobile = true;
        $searchBarInputMobile.addClass('hidden');
        $mobileAddressInput.removeClass('hidden');

        if ($makeAppointmentBar.hasClass('nopostcodesearch')) {
            $makeAppointmentBar.hide();
        }

    } else if ($(window).width() >= 768 && mobile) {
        mobile = false;

        $bookOnlineButton.show();

        $searchBarIconDesktop.removeClass('dim');
        $easilyBookOnline.removeClass('hidden');
        $searchBarInputMobile.addClass('hidden');
        $searchBarInputDesktop.addClass('hidden');
        $desktopAddressInput.removeClass('hidden');
        $makeAppointmentBar.show();
    }
});
